import { render, staticRenderFns } from "./dispatches-wrapper.vue?vue&type=template&id=07d982d2"
import script from "./dispatches-wrapper.vue?vue&type=script&lang=ts"
export * from "./dispatches-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports